import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { twMerge } from 'tailwind-merge';
const PaginationButton = ({
  className = '',
  isActive = false,
  disabled,
  children,
  ...anchorProps
}) => /*#__PURE__*/React.createElement("a", _extends({}, anchorProps, {
  "data-cy": anchorProps.id,
  role: "button",
  className: twMerge('hover:bg-gray-200 hover:font-bold', 'flex items-center justify-center w-12 h-12 text-sm border-0 border-solid cursor-pointer', isActive && 'font-bold bg-gray-200 pointer-events-none', disabled ? 'pointer-events-none text-gray-500 bg-gray-200' : 'text-blue-700', className)
}), children);
export default PaginationButton;